import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthRoutes from "../routes/AuthRoutes";
import AppRoutes from "../routes/AppRoutes";
import FeedbackSubmitPage from "../screens/FeedbackSubmitPage";
import EmailToTicketForm from "../screens/MailTicket/EmailToTicketForm";
import RouteWatcher from "../Components/RouterWatcher";
import TSignUp from "../screens/ticketingSignUp/TSignUp";
const MainRoutes = () => {
  return (
    <div>
      <RouteWatcher />
      <Routes>
        <Route path="*" element={<Navigate to="/auth" />} />
        <Route path="auth/*" element={<AuthRoutes />} />
        <Route path="app/*" element={<AppRoutes />} />
        <Route path="feedback/*" element={<FeedbackSubmitPage />} />
        <Route path="emailtoticket/*" element={<EmailToTicketForm />} />
        <Route path="tSignUp/" element={<TSignUp />} />
      </Routes>
    </div>
  );
};
export default MainRoutes;
